export default __webpack_public_path__ + "img/effa7770b99d94755c19c35adfc88baa.svg";